<div class="modal-header">
  <h4 class="modal-title">{{ 'moveArticlePopup.title' | translate }}</h4>
</div>
<div class="modal-body pt-0" *ngIf="initialized">
  <div class="modal-body-inner">
    <p>{{ 'moveArticlePopup.label' | translate }}:</p>
    <div class="ps-5">
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="moveOperationsButtonGroup"
          id="moveFromStartRadioButton"
          [value]="MOVE_FROM_PARENT_ARTICLE_START"
          [checked]="selectedOperation === MOVE_FROM_PARENT_ARTICLE_START"
          (change)="onSelectionChange(MOVE_FROM_PARENT_ARTICLE_START)"
        />
        <label class="form-check-label" for="moveFromStartRadioButton">
          {{ getMoveFromStartRadioButtonLabel(rangeOnLineArticleType) | translate }}
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="moveOperationsButtonGroup"
          id="moveFromLastRadioButton"
          [value]="MOVE_FROM_LAST_ARTICLE_BEFORE_SELECTION"
          [checked]="selectedOperation === MOVE_FROM_LAST_ARTICLE_BEFORE_SELECTION"
          [disabled]="!lastArticleBeforeSelectionExists"
          (change)="onSelectionChange(MOVE_FROM_LAST_ARTICLE_BEFORE_SELECTION)"
        />
        <label class="form-check-label" for="moveFromLastRadioButton">
          {{ getMoveFromLastBeforeSelectionRadioButtonLabel(rangeOnLineArticleType) | translate }}
        </label>
      </div>
      <div class="form-check">
        <input
          class="form-check-input"
          type="radio"
          name="moveOperationsButtonGroup"
          id="moveByPositionRadioButton"
          [value]="MOVE_BY_ARTICLE_POSITION"
          [checked]="selectedOperation === MOVE_BY_ARTICLE_POSITION"
          [disabled]="getAllowedMovePositions().length <= 0"
          (change)="onSelectionChange(MOVE_BY_ARTICLE_POSITION)"
        />
        <label class="form-check-label" for="moveByPositionRadioButton">
          {{ 'moveArticlePopup.label.move_by_article_position' | translate }}
        </label>
      </div>
    </div>
    <hr />
    <form
      [formGroup]="formDistance"
      class="mb-3 row"
      *ngIf="selectedOperation === MOVE_FROM_PARENT_ARTICLE_START || selectedOperation === MOVE_FROM_LAST_ARTICLE_BEFORE_SELECTION"
    >
      <label class="col-md-3 col-form-label text-end font-weight-bold" for="moveArticlesDistanceInput">
        {{ 'moveArticlePopup.label.distance' | translate }}:
      </label>
      <div class="col-md-4">
        <div class="input-group">
          <input
            class="form-control"
            spellcheck="false"
            type="text"
            id="moveArticlesDistanceInput"
            inputRestricter="^[0-9\.,]*$"
            formControlName="distance"
            (inputEvent)="formDistance.controls.distance.setValue($event)"
            [class.is-invalid]="formDistance.controls.distance.invalid"
          />
          <div class="input-group-append">
            <span class="input-group-text">{{ 'global.unit.label.mm' | translate }}</span>
          </div>
          <div class="invalid-feedback">
            {{ formDistance.controls.distance.errors?.messageKey | translate : { '0': formDistance.controls.distance.errors?.param } }}
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="formPosition" class="mb-3 row" *ngIf="selectedOperation === MOVE_BY_ARTICLE_POSITION">
      <label class="col-md-3 col-form-label text-end font-weight-bold" for="moveArticlesPositionInput">
        {{ 'moveArticlePopup.label.position' | translate }}:
      </label>
      <div class="col-md-4">
        <input
          class="form-control"
          type="text"
          spellcheck="false"
          id="moveArticlesPositionInput"
          inputRestricter="^[0-9]*$"
          formControlName="position"
          (inputEvent)="formPosition.controls.position.setValue($event)"
          [class.is-invalid]="formPosition.controls.position.invalid && formPosition.controls.position.touched"
        />
        <div class="invalid-feedback">
          {{ formPosition.controls.position.errors?.messageKey | translate : { '0': formPosition.controls.position.errors?.param } }}
        </div>
      </div>
    </form>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-secondary btn-cancel" (click)="close()">{{ 'global.label.close' | translate }}</button>
  <button class="btn btn-primary btn-forward" (click)="nextButton_clickHandler()" [disabled]="!(initialized && selectedOperation !== null)">
    {{ 'global.label.apply' | translate }}
  </button>
</div>
